import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M9 10a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1l0 -4","key":"svg-1"}],["path",{"d":"M3 12h6","key":"svg-2"}]]

const IconBrandUber = createReactComponent('outline', 'brand-uber', 'BrandUber', __iconNode);

export default IconBrandUber;